export const Footer = () => (
  <div className="so-back LaboratoryChrome__terms" data-testid="page-footer">
    <div className="so-chunk ">
      <a
        rel="noreferrer"
        target="_blank"
        href="https://www.stellar.org/terms-of-service"
      >
        Terms of Service
      </a>
      <span className="spacer" />
      <a
        rel="noreferrer"
        target="_blank"
        href="https://www.stellar.org/privacy-policy"
      >
        Privacy Policy
      </a>
    </div>
  </div>
);
